<template>
<v-flex fill-height v-if="!loading"  >
    <v-card color="grey darken-1 " class="mb-3"  tile width="100%" :href="topBanner && topBanner.url" target="_blank" v-if="topBanner.file">
        <v-img :src="topBanner && `https://b2b.yugcontract.ua/fileslibrary/banners/` + topBanner.file" position="center" height="100%" ></v-img>
    </v-card>
    <v-card color="grey darken-1 "  tile width="100%" :href="bottomBanner && bottomBanner.url" target="_blank" v-if="bottomBanner.file">
        <v-img :src="bottomBanner && `https://b2b.yugcontract.ua/fileslibrary/banners/` + bottomBanner.file" position="center" height="100%" ></v-img>
    </v-card>
</v-flex>
</template>

<script>
import {
    mapActions
} from 'vuex'

export default {
    data() {
        return {
            ...mapActions(['touch', 'getStaticBanners']),
            topBanner: {},
            bottomBanner: {},
            loading: false
        }
    },
    methods: {},
    created() {
        this.touch()
            .then(data => {
                this.loading = true
                this.getStaticBanners({
                        placeId: 2
                    })
                    .then(data =>
                        this.topBanner = data
                    )
                this.getStaticBanners({
                        placeId: 3
                    })
                    .then(data =>
                        this.bottomBanner = data
                    )
            })
            .finally(() => {
                this.loading = false
            })
            .catch(error => console.error(error))
    },
    computed: {},
}
</script>
